import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class MaterialGet extends PlusComponent {
  constructor(props) {
    super(props, "contentMaterial");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentMaterial"></ContentSettings>
        </div>
      )
    }
}

export default MaterialGet;